export default __webpack_public_path__ + "static/media/banner2.7a38e6fc.png";